import { Firestore } from 'firebase/firestore'
import { FirebaseStorage } from 'firebase/storage'

export let db: Firestore
export let storage: FirebaseStorage

export function setDatabase(newDatabase: Firestore) {
	db = newDatabase
}

export function setStorage(newStorage: FirebaseStorage) {
	storage = newStorage
}
